import request from '@/utils/request'

let VehicleApi = {

  /*验车服务列表*/
  list(data) {
    return request._post('/shop/plus.vehicle.Index/index', data);
},
/*添加验车服务*/
add(data) {
    return request._post('/shop/plus.vehicle.Index/add', data);
},
/*修改验车服务*/
edit(data) {
    return request._post('/shop/plus.vehicle.Index/edit', data);
},
/*删除验车服务*/
del(data) {
    return request._post('/shop/plus.vehicle.Index/del', data);
},
/*验车服务详情*/
detail(data) {
  return request._post('/shop/plus.vehicle.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.vehicle.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.vehicle.Setting/getSetting', data, errorback);
    },
}
export default VehicleApi;



// WEBPACK FOOTER //
// ./src/api/vehicle.js